import styled, { css } from 'styled-components';

export const StepperContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: ${(p) => p.theme.spacing.sm} 0;

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    padding: ${(p) => p.theme.spacing.xs} 0;
  }
`;

export const StepperWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  width: 100%;
  max-width: 600px;

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    gap: 0;
  }
`;

interface StepItemProps {
  $isActive: boolean;
  $isCompleted: boolean;
  $isClickable: boolean;
}

export const StepItem = styled.div<StepItemProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1;
  cursor: ${(p) => (p.$isClickable ? 'pointer' : 'default')};

  &:hover {
    ${(p) =>
      p.$isClickable &&
      css`
        opacity: 0.8;
      `}
  }
`;

export const StepCircle = styled.div<StepItemProps>`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${(p) => p.theme.font.weight.semibold};
  font-size: ${(p) => p.theme.font.size.xs};
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;

  ${(p) =>
    p.$isCompleted &&
    css`
      background-color: ${p.theme.colors.general.success};
      color: ${p.theme.colors.general.white};
      border: 2px solid ${p.theme.colors.general.success};
    `}

  ${(p) =>
    p.$isActive &&
    !p.$isCompleted &&
    css`
      background-color: ${p.theme.colors.general.primary};
      color: ${p.theme.colors.general.white};
      border: 2px solid ${p.theme.colors.general.primary};
      box-shadow: 0 0 0 4px rgba(20, 118, 255, 0.2);
    `}

  ${(p) =>
    !p.$isActive &&
    !p.$isCompleted &&
    css`
      background-color: ${p.theme.colors.general.white};
      color: ${p.theme.colors.grey[50]};
      border: 2px solid ${p.theme.colors.grey[30]};
    `}

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 32px;
    height: 32px;
    font-size: ${(p) => p.theme.font.size.xxs};
  }
`;

export const StepLabel = styled.span<StepItemProps>`
  margin-top: 8px;
  font-size: ${(p) => p.theme.font.size.xxs};
  font-weight: ${(p) => (p.$isActive ? p.theme.font.weight.semibold : p.theme.font.weight.normal)};
  text-align: center;
  max-width: 80px;
  line-height: 1.2;

  ${(p) =>
    p.$isCompleted &&
    css`
      color: ${p.theme.colors.general.success};
    `}

  ${(p) =>
    p.$isActive &&
    !p.$isCompleted &&
    css`
      color: ${p.theme.colors.general.primary};
    `}

  ${(p) =>
    !p.$isActive &&
    !p.$isCompleted &&
    css`
      color: ${p.theme.colors.grey[50]};
    `}

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    font-size: ${(p) => p.theme.font.size.tiny};
    max-width: 60px;
    display: none;
  }
`;

interface StepConnectorProps {
  $isCompleted: boolean;
}

export const StepConnector = styled.div<StepConnectorProps>`
  height: 2px;
  flex: 1;
  margin: 0 -8px;
  margin-top: -18px;
  transition: background-color 0.2s ease;

  ${(p) =>
    p.$isCompleted
      ? css`
          background-color: ${p.theme.colors.general.success};
        `
      : css`
          background-color: ${p.theme.colors.grey[30]};
        `}

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    margin: 0 -4px;
    margin-top: -16px;
  }
`;

export const CheckIcon = styled.svg`
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 3;
  stroke-linecap: round;
  stroke-linejoin: round;
`;
